module.exports = __webpack_public_path__ + "static/media/penalty.2e0cc854.svg";